import { createContext, useContext } from 'react';
import type { Me } from '@pb/shared';

export interface SessionState {
  me: Me | null;
  setMe: (me: Me | null) => void;
}

export const SessionContext = createContext<SessionState>({ me: null, setMe: () => undefined });

export const useSession = () => useContext(SessionContext);
